import { I18n } from 'common/i18n';
import * as constants from 'common/components/AssetBrowser/lib/constants';
import { SelectDropdownConfig } from './filter-config';
import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterScope, getAllOption, getScope } from './translations';
import { FilterType } from './types';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';

const scope = getScope(FilterScope.Version);

const getVersionOptions = (list?: string[]): IBaseListDropdownOption<string | null>[] => {
  const versionOptions: IBaseListDropdownOption<string | null>[] = [getAllOption(scope)];

  list?.forEach((version) => {
    if (version === 'published') {
      versionOptions.push({
        label: I18n.t('options.published', { scope }),
        value: constants.VERSION_PUBLISHED,
      });
    } else if (version === 'draft') {
      versionOptions.push({
        label: I18n.t('options.draft', { scope }),
        value: constants.VERSION_DRAFT,
      });
    }
  });

  return versionOptions;
};

export const versionConfigs: SelectDropdownConfig = {
  filterName: Filters.Version,
  label: I18n.t('label', { scope }),
  getOptions: getVersionOptions,
  dispatchAction: filters.changeVersion,
  filterType: FilterType.SelectDropdown,
  filterListName: FilterList.AllowedVersions,
};
